import { Directive, Input, OnInit, OnDestroy } from '@angular/core';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appAutocompleteNoData]'
})
export class AutocompleteNoDataDirective implements OnInit, OnDestroy {

  @Input('appAutocompleteNoData') itemList: any[] = [];
  @Input() displayKey: string = '';

  private displaySubscription?: Subscription;

  constructor(private autocomplete: MatAutocomplete) {}

  ngOnInit() {
    this.displaySubscription = this.autocomplete.opened.subscribe(() => {
      this.checkNoDataFound();
    });
  }

  private checkNoDataFound() {
    if (this.itemList.length === 0) {
      const noDataOption = { [this.displayKey]: 'No Data Found' };
      this.itemList.push(noDataOption);
    } else {
      const noDataIndex = this.itemList.findIndex(item => item[this.displayKey] === 'No Data Found');
      if (noDataIndex >= 0) {
        this.itemList.splice(noDataIndex, 1);
      }
    }
  }

  ngOnDestroy() {
    if (this.displaySubscription) {
      this.displaySubscription.unsubscribe();
    }
  }
}
